import React, { useEffect, useState } from 'react';
import { Icon, IconLoader } from 'components/common/Icon';
import { useProxyHealth } from '../use-proxy-health';
import { checkCircleIcon, alertCircleIcon } from 'assets/icons';
import { RequestStatus } from 'react-app-env';
import backend from 'api-services/backend-service';
import { shouldMockBackend } from 'test-utils/mocks/should-mock-backend';

const Row = ({
  title, status, okMessage, errMessage,
}: { title: string, status: RequestStatus | 'Mocked', okMessage?: React.ReactNode, errMessage?: React.ReactNode
}) => {
  const cellStyles = 'text-left';
  return <tr>
    <th className={cellStyles}>{title}</th>
    <td className={cellStyles}>
      {status === 'Loading' && <IconLoader />}
      {status === 'Ok' && <Icon src={checkCircleIcon} />}
      {status === 'Error' && <Icon src={alertCircleIcon} />}
    </td>
    <td className={cellStyles}>
      {status === 'Ok' && <span>{okMessage || status}</span>}
      {status === 'Error' && <span className='text-red-600'>{errMessage || status}</span>}
      {status === 'Mocked' && <span>{status}</span>}
    </td>
  </tr>;
};

const ProxyStatusRows = () => {
  const [proxyStatus, proxyStatusMessage] = useProxyHealth();

  return <>
    <Row
      title='Unleash proxy health'
      status={proxyStatus}
      okMessage={proxyStatusMessage}
      errMessage={proxyStatusMessage} />
  </>;
};

const StatusAdmin = () => {
  const [backendStatus, setBackendStatus] = useState<RequestStatus | 'Mocked'>('Loading');

  useEffect(() => {
    if (shouldMockBackend()) {
      setBackendStatus('Mocked');
    } else {
      backend.options('products')
        .then(() => setBackendStatus('Ok'))
        .catch(() => setBackendStatus('Error'));
    }
  }, []);

  return <div>
    <table className='divide-y divide-gray-200 w-full mt-4 mb-8'>
      <tbody>
        <Row
          title='Backend'
          status={backendStatus} />
        <Row
          title='Environment'
          status={process.env.NODE_ENV && process.env.NODE_ENV.length > 0 ? 'Ok' : 'Error'}
          okMessage={<span className='font-mono'>{process.env.NODE_ENV}</span>}
          errMessage='Not set' />
        <ProxyStatusRows />
      </tbody>
    </table>
  </div>;
};

export default StatusAdmin;
